import React, { memo, useState } from "react";
import { FieldArray, FormikProps, useFormikContext } from "formik";
import { CardType, Data } from "../../../store/processor/types";
import {
  Grid,
  Box,
  Button,
  Accordion,
  AccordionSummary,
  Typography,
  AccordionDetails,
} from "@mui/material";
import pageStyles from "../../pageStyles";
import SectionWrapper from "../../../common/pageSections/SectionWrapper";
import { Add, Delete, ExpandMore, Payment } from "@mui/icons-material";
import ProcessorCardTypeForm from "./ProcessorCardTypeForm";
import Confirm from "../../../common/confirm/Confirm";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../../store";

const ProcessorCardType = () => {
  const formikProps = useFormikContext();
  const { values } = formikProps as FormikProps<Data>;

  const styles = pageStyles();
  const [showConfirm, setShowConfirm] = useState(false);
  const [deleteItemId, setDeleteItemId] = useState(0);

  const cardtypeObj: CardType = {
    ProductID: "",
    ProductName: "",
    AmountFrom: 0,
    AmountTo: 0,
  };

  return (
    <SectionWrapper title="CardType" isChild isWhiteBG>
      <FieldArray
        name="attributes.CardType"
        render={(arrayHelpers) => {
          return (
            <>
              {values.attributes?.CardType?.map((cardtype: CardType, index) => {
                return (
                  <Accordion key={index} className={styles.Accordion as string}>
                    <AccordionSummary
                      expandIcon={<ExpandMore />}
                      aria-controls={`${index}_content`}
                      id={`${index}_header`}
                    >
                      <Box className={styles.processorTitleWrapper as string}>
                        <Typography className={styles.processorTitle as string}>
                          <Payment style={{ marginRight: "5px" }} />
                          {cardtype.ProductName || `CardType ${index + 1}`}
                        </Typography>
                        <Button
                          color="secondary"
                          variant="outlined"
                          onClick={() => {
                            setDeleteItemId(index);
                            setShowConfirm(true);
                          }}
                          size="small"
                          startIcon={<Delete />}
                        >
                          Delete
                        </Button>
                      </Box>

                      <Confirm
                        isOpen={showConfirm}
                        onCancel={() => setShowConfirm(false)}
                        onConfirm={() => {
                          arrayHelpers.remove(deleteItemId);
                          setShowConfirm(false);
                        }}
                        title="Delete CardType"
                        icon="danger"
                        confirmLabel="Delete"
                        contentText={`You are about to delete a CardType`}
                      />
                    </AccordionSummary>
                    <AccordionDetails
                      style={{
                        background: "#fff",
                        borderTop: "1px solid #efefef",
                      }}
                    >
                      <Grid container style={{ marginTop: "15px" }}>
                        <Grid item xs={12}>
                          <ProcessorCardTypeForm index={index} cardtype={cardtype} />
                        </Grid>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                );
              })}

              <Grid item xs={12}>
                <Box textAlign="center">
                  <Button
                    color="primary"
                    variant="contained"
                    size="medium"
                    endIcon={<Add />}
                    onClick={() => arrayHelpers.push(cardtypeObj)}
                    style={{ marginTop: "15px" }}
                  >
                    Create CardType
                  </Button>
                </Box>
              </Grid>
            </>
          );
        }}
      />
    </SectionWrapper>
  );
};

export default memo(ProcessorCardType);
